/**
 * Move V2 async thunks
 *
 * Endpoints (fp-api handheld.rest.xml):
 * - Validate origin:    GET  /rest/s1/handheld/facility/{facilityId}/scanIdGeneral
 * - Location contents:  GET  /rest/s1/handheld/moveV2/locationContents
 * - Classify scan:      GET  /rest/s1/handheld/moveV2/scanResult
 * - Resolve source:     GET  /rest/s1/handheld/moveV2/source
 * - Resolve destination:GET  /rest/s1/handheld/moveV2/destination
 * - Perform move:       POST /rest/s1/handheld/moveV2/move
 *
 * All thunks resolve to shaped results (never reject) so the UI can show inline
 * scan errors and map server error codes to copy.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
var authHeaders = function () {
    var _a;
    return ({
        moquiSessionToken: (_a = localStorage.getItem('moquiSessionToken')) !== null && _a !== void 0 ? _a : ''
    });
};
var getFacilityId = function () { var _a; return (_a = localStorage.getItem('facilityId')) !== null && _a !== void 0 ? _a : ''; };
// const getActiveOrgId = () => localStorage.getItem('activeOrgId') ?? ''
// Workstation location types are not valid move origins or destinations.
var DISALLOWED_LOCATION_TYPES = ['FltCart', 'FltPack'];
var errorText = function (e, fallback) { var _a, _b, _c, _d, _e, _f; return ((_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) || ((_f = (_e = (_d = (_c = e === null || e === void 0 ? void 0 : e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errorsList) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.message) || fallback; };
// Resolve a scanned origin location to its canonical seqId; cart/pack rejected.
export var validateMoveOrigin = createAsyncThunk('move/validateOrigin', function (_a) {
    var rawLocation = _a.rawLocation;
    return __awaiter(void 0, void 0, void 0, function () {
        var scanId, facilityId, response, data, locationSeqId, locationTypeEnumId, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    scanId = (rawLocation || '').trim();
                    facilityId = getFacilityId();
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + encodeURIComponent(scanId), { headers: authHeaders() })];
                case 2:
                    response = _d.sent();
                    data = response === null || response === void 0 ? void 0 : response.data;
                    locationSeqId = data === null || data === void 0 ? void 0 : data.locationSeqId;
                    locationTypeEnumId = (_c = data === null || data === void 0 ? void 0 : data.facilityLocation) === null || _c === void 0 ? void 0 : _c.locationTypeEnumId;
                    if ((data === null || data === void 0 ? void 0 : data.messages) || !locationSeqId) {
                        return [2 /*return*/, { ok: false, error: 'Incorrect location, scan again' }];
                    }
                    if (DISALLOWED_LOCATION_TYPES.includes(locationTypeEnumId)) {
                        return [2 /*return*/, { ok: false, error: 'Incorrect location, scan again' }];
                    }
                    return [2 /*return*/, { ok: true, locationSeqId: locationSeqId, locationType: locationTypeEnumId }];
                case 3:
                    _b = _d.sent();
                    return [2 /*return*/, { ok: false, error: 'Failed to validate location. Try again.' }];
                case 4: return [2 /*return*/];
            }
        });
    });
});
// Contents of the origin location (containers one-depth tree + loose products).
export var fetchMoveLocationContents = createAsyncThunk('move/fetchLocationContents', function (_a) {
    var locationSeqId = _a.locationSeqId;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, response, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    facilityId = getFacilityId();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/moveV2/locationContents", {
                            params: { facilityId: facilityId, locationSeqId: locationSeqId },
                            headers: authHeaders()
                        })];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || { ok: false }];
                case 3:
                    e_1 = _b.sent();
                    return [2 /*return*/, { ok: false, errorMessage: errorText(e_1, 'Could not load location contents') }];
                case 4: return [2 /*return*/];
            }
        });
    });
});
// Unified first scan: classify a scan with no origin (location / unit-with-derived-origin / product).
export var resolveMoveScanResult = createAsyncThunk('move/resolveScanResult', function (_a) {
    var scanId = _a.scanId;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, response, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    facilityId = getFacilityId();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/moveV2/scanResult", {
                            params: { facilityId: facilityId, scanId: (scanId || '').trim() },
                            headers: authHeaders()
                        })];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || { ok: false }];
                case 3:
                    e_2 = _b.sent();
                    return [2 /*return*/, { ok: false, errorMessage: errorText(e_2, 'Could not resolve that scan') }];
                case 4: return [2 /*return*/];
            }
        });
    });
});
// Resolve a "what am I moving" scan in origin-location context.
export var resolveMoveSource = createAsyncThunk('move/resolveSource', function (_a) {
    var originLocationSeqId = _a.originLocationSeqId, scanId = _a.scanId, productId = _a.productId;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, params, response, e_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    facilityId = getFacilityId();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    params = {
                        facilityId: facilityId,
                        originLocationSeqId: originLocationSeqId,
                        scanId: (scanId || '').trim()
                    };
                    // productId pins resolution to a specific product (a disambiguation pick) so the scan is not
                    // re-expanded by SKU/UPC into a different product.
                    if (productId)
                        params.productId = productId;
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/moveV2/source", {
                            params: params,
                            headers: authHeaders()
                        })];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || { ok: false }];
                case 3:
                    e_3 = _b.sent();
                    return [2 /*return*/, { ok: false, errorMessage: errorText(e_3, 'Could not resolve that scan') }];
                case 4: return [2 /*return*/];
            }
        });
    });
});
// Resolve a destination scan for the chosen move unit.
export var resolveMoveDestination = createAsyncThunk('move/resolveDestination', function (_a) {
    var scanId = _a.scanId, moveUnitKind = _a.moveUnitKind, sourceContainerId = _a.sourceContainerId, sourceLocationSeqId = _a.sourceLocationSeqId;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, response, e_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    facilityId = getFacilityId();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/moveV2/destination", {
                            params: {
                                facilityId: facilityId,
                                scanId: (scanId || '').trim(),
                                moveUnitKind: moveUnitKind,
                                sourceContainerId: sourceContainerId || undefined,
                                sourceLocationSeqId: sourceLocationSeqId || undefined,
                            },
                            headers: authHeaders()
                        })];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || { ok: false }];
                case 3:
                    e_4 = _b.sent();
                    return [2 /*return*/, { ok: false, errorMessage: errorText(e_4, 'Could not resolve that destination') }];
                case 4: return [2 /*return*/];
            }
        });
    });
});
// Execute the move. The server re-validates everything at commit time, so a
// stale confirm fails loudly instead of moving the wrong thing.
export var performMove = createAsyncThunk('move/perform', function (args) { return __awaiter(void 0, void 0, void 0, function () {
    var facilityId, body, response, e_5;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                facilityId = getFacilityId();
                body = __assign({ facilityId: facilityId }, args);
                Object.keys(body).forEach(function (k) {
                    if (body[k] === undefined || body[k] === null || body[k] === '')
                        delete body[k];
                });
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post("/rest/s1/handheld/moveV2/move", body, {
                        headers: authHeaders()
                    })];
            case 2:
                response = _d.sent();
                if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.result) {
                    return [2 /*return*/, { ok: true, message: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message }];
                }
                return [2 /*return*/, { ok: false, error: ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.message) || 'Move failed' }];
            case 3:
                e_5 = _d.sent();
                return [2 /*return*/, { ok: false, error: errorText(e_5, 'Move failed') }];
            case 4: return [2 /*return*/];
        }
    });
}); });
